// src/actions/chargesSettingsActions.js
import {
  GET_PLATFORM_SETTINGS_REQUEST,
  GET_PLATFORM_SETTINGS_SUCCESS,
  GET_PLATFORM_SETTINGS_FAIL,
  SAVE_PLATFORM_SETTINGS_REQUEST,
  SAVE_PLATFORM_SETTINGS_SUCCESS,
  SAVE_PLATFORM_SETTINGS_FAIL,
  baseURL
} from './types';

import axios from 'axios';

// Get token from localStorage
const getAuthToken = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  return loginData.token || '';
};

// Get Platform Settings
export const getPlatformSettings = (hospitalID) => async (dispatch) => {
  try {
    dispatch({ type: GET_PLATFORM_SETTINGS_REQUEST });

    const token = getAuthToken();

    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };

    // Using POST with hospitalID in request body
    const { data } = await axios.post(`${baseURL}/api/appointementPlatformChargesSetting/getall`, { hospitalID }, config);

    dispatch({
      type: GET_PLATFORM_SETTINGS_SUCCESS,
      payload: data
    });

    return Promise.resolve(data);
  } catch (error) {
    dispatch({
      type: GET_PLATFORM_SETTINGS_FAIL,
      payload: error.response?.data?.message || error.message
    });
    return Promise.reject(error);
  }
};

// Save/Update Platform Settings
export const savePlatformSettings = (settingsData) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_PLATFORM_SETTINGS_REQUEST });

    const token = getAuthToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };

    // Use PATCH for update, POST for create
    let response;
    if (settingsData.id) {
      // Use PATCH for update
      response = await axios.patch(
        `${baseURL}/api/appointementPlatformChargesSetting/update`, 
        settingsData, 
        config
      );
    } else {
      // Use POST for create
      response = await axios.post(
        `${baseURL}/api/appointementPlatformChargesSetting/create`, 
        settingsData, 
        config
      );
    }

    dispatch({
      type: SAVE_PLATFORM_SETTINGS_SUCCESS,
      payload: response.data
    });

    return Promise.resolve(response.data);
  } catch (error) {
    dispatch({
      type: SAVE_PLATFORM_SETTINGS_FAIL,
      payload: error.response?.data?.message || error.message
    });
    return Promise.reject(error);
  }
};